<template>
  
  <!-- Cookie Consent Panel -->
  <div class="pa-1 d-flex flex-wrap align-center justify-md-space-between justify-center ga-4 w-100">
    
    
    <!-- Description section -->
    <div>
      <p class="cookie_section_text ma-0">We use cookies to improve your experience on our site. 
        You can choose which types of cookies to allow. 
        Note that blocking some types of cookies may impact your experience. 
        <a class="cookies_link" href="doc.php?doc=cookies.htm" target="_blank">Cookie Policy</a></p>
    </div>
    
    <!-- Divider Line -->
    <v-divider class="mb-4"></v-divider>
    
    <!-- Necessary Cookies Section -->
    <div>
      <span class="d-flex justify-center">
        <h3 class="text-start w-100">Necessary Cookies</h3>
        <Toggle id="toggle-necessary" :model-value="true" :disabled="true" />
      </span>
      <p class="cookie_section_text">These cookies are essential for the website to function properly. They enable basic functions like page navigation and access to secure areas. The website cannot function properly without these cookies.</p>
    </div>
    
    <!-- Divider Line -->
    <v-divider class="mb-4"></v-divider>
    
    <!-- Functional Cookies Section -->
    <div>
      <span class="d-flex justify-center">
        <h3 class="text-start w-100">Functional Cookies</h3>
        <Toggle id="toggle-functional" v-model="functional" />
      </span>
      <p class="cookie_section_text">These cookies enable enhanced functionality and personalisation, such as videos and live chats. They may be set by us or by third-party providers whose services we've added to our pages.</p>
    </div>

    <!-- Divider Line -->
    <v-divider class="mb-4"></v-divider>

    <!-- Analytics Cookies Section -->
    <div>
      <span class="d-flex justify-center">
        <h3 class="text-start w-100">Analytics Cookies</h3>
        <Toggle id="toggle-analytics" v-model="analytics" />
      </span>
      <p class="cookie_section_text">These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. This helps us improve our website and services.</p>
    </div>
    
    <!-- Divider Line -->
    <v-divider class="mb-4"></v-divider>
    
    <!-- Marketing Cookies Section -->
    <!-- <div>
      <span class="d-flex justify-center">
        <h3 class="text-start w-100">Marketing Cookies</h3>
        <Toggle
        :model-value="true" />
      </span>
      <p class="cookie_section_text">These cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and advertisers.</p>
    </div> -->
    
    <!-- Divider Line -->
    <!-- <v-divider class="mb-2"></v-divider> -->
    
    <!-- Buttons section -->
    <div class="d-flex flex-wrap justify-end ga-2 w-100">
      <Button
      :slim="true"
      version="action"
      label="Save Preferences"
      @click="savePreferences"
      />
      <Button
      :slim="true"
      version="primary"
      label="Accept All"
      @click="acceptAll"
      />
    </div>
    
  </div>
  
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useModalStore } from '@/store/modalStore';
import { useBottomSheetStore } from '@/store/bottomSheetStore';
import { acceptAllConsent, setConsentPreferences } from '@/services/consent/cookieConsentService';

import Button from '../ComponentLibrary/Button.vue';
import Toggle from '../ComponentLibrary/Toggle.vue';

// Stores
const modalStore = useModalStore();
const bottomSheetStore = useBottomSheetStore();

// Toggle state (default opt-in)
const functional = ref(true);
const analytics = ref(true);

const closeAll = () => {
  modalStore.closeModal();
  bottomSheetStore.closeSheet();
};

const savePreferences = () => {
  setConsentPreferences({ functional: functional.value, analytics: analytics.value, marketing: false });
  closeAll();
};

const acceptAll = () => {
  acceptAllConsent();
  closeAll();
};
</script>

<style lang="scss">

.cookie_section_text {
  width: 90%;
  text-align: left;
}

.cookies_link {
  color: $secondary;
}
</style>